/**
 * Testimonials Swiper
 *
 * Importa apenas os módulos necessários do Swiper — Vite/Rollup faz tree-shaking
 * do restante. SCSS do Swiper é omitido intencionalmente: os estilos de base
 * estão integrados no _testimonials.scss do tema (via variáveis do tema).
 *
 * Módulos usados:
 *   - Swiper core
 *   - Autoplay   — avanço automático com pausa no hover
 *   - Pagination — dots indicadores
 *   - A11y       — aria-labels e foco por teclado
 */
import Swiper from 'swiper';
import { Autoplay, Pagination, A11y } from 'swiper/modules';

document.addEventListener('DOMContentLoaded', () => {
  const container = document.querySelector('.testimonials-swiper');
  if (!container) return;

  new Swiper('.testimonials-swiper', {
    // Módulos registrados — tree-shaking elimina os não listados aqui
    modules: [Autoplay, Pagination, A11y],

    // Layout: 1 slide visível + peek do próximo
    slidesPerView: 1.1,
    spaceBetween: 20,
    centeredSlides: false,

    // Breakpoints responsivos
    breakpoints: {
      // ≥ 480px — 1 slide completo
      480: {
        slidesPerView: 1.15,
        spaceBetween: 20,
      },
      // ≥ 768px — 2 slides
      768: {
        slidesPerView: 2.1,
        spaceBetween: 24,
        centeredSlides: false,
      },
      // ≥ 992px — 3 slides completos
      992: {
        slidesPerView: 3,
        spaceBetween: 24,
        centeredSlides: false,
      },
    },

    // Autoplay com pausa ao interagir
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,  // retoma após swipe manual
      pauseOnMouseEnter: true,
    },

    // Dots de paginação
    pagination: {
      el: '.testimonials-swiper-pagination',
      clickable: true,
    },

    // Acessibilidade
    a11y: {
      prevSlideMessage: 'Depoimento anterior',
      nextSlideMessage: 'Próximo depoimento',
    },

    // Loop infinito — desativado
    loop: false,

    // Grab cursor no desktop
    grabCursor: true,
  });
});
